export default __webpack_public_path__ + "static/bitcoin_at_glance-fdfa0cdc65c5a206cc405644cf36b888.png";